import { Field } from "formik";
import moment from "moment";
import Date from "pages/_components/fields/DateField";
import Selector from "pages/_components/fields/formik/Selector";
import TextField from "pages/_components/fields/TextField";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool, instanceOf, string } from "prop-types";
import React from "react";
import * as i18n from "util/i18n";

const textField = {
    TEXT_FIELD: { ALF: "text", IMP: "number" },
    HIDDEN_TEXT_FIELD: {
        ALF: "password",
    },
};

const today = moment();

export const DynamicForm = ({ forms, idForm, disabled, docType }) => {
    let type;
    switch (docType) {
        case "01":
            type = "DNI";
            break;
        case "02":
            type = "CUIT";
            break;
        case "03":
            type = "CLIENTE";
            break;
        case "04":
            type = "FACTURA";
            break;
        default:
            type = "";
    }
    return (
        <>
            {forms.map((form) => {
                if (textField[form.component]) {
                    if (form.dataType === "FEC") {
                        return (
                            <GridTable.Container key={`${idForm}-${form.field}`} columns={12} columnsTemplate="fixed">
                                <GridTable.Data columnStart={2} columnWidth={10}>
                                    <Field
                                        component={Date}
                                        idForm={idForm}
                                        labelText={form.label}
                                        name={form.field}
                                        dateFormat="YYYY-MM-DD"
                                        minDate={today.add(-100, "years")}
                                        hidePlaceholder
                                        disabled={disabled}
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        );
                    }

                    return (
                        <GridTable.Container key={`${idForm}-${form.field}`} columns={12} columnsTemplate="fixed">
                            <GridTable.Data columnStart={2} columnWidth={10}>
                                <Field
                                    component={TextField}
                                    idForm={idForm}
                                    labelnoI18n={`${form.label} ${type}`}
                                    name={form.field}
                                    type={textField[form.component][form.dataType]}
                                    maxLength={form.length}
                                    disabled={disabled}
                                    hidePlaceholder
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    );
                }

                if (form.component === "COMBO_BOX_ESTATICO") {
                    const formatOptions = (options) =>
                        // ARBIBIMPLE-8776: Como value se deja el mismo label por pedido via mail de Rapipago
                        Object.entries(options).map((option) => ({ value: option[1], label: option[1] }));
                    return (
                        <GridTable.Container key={`${idForm}-${form.field}`} columns={12} columnsTemplate="fixed">
                            <GridTable.Data columnStart={2} columnWidth={10}>
                                <Field
                                    component={Selector}
                                    idForm={idForm}
                                    name={form.field}
                                    label={form.label}
                                    options={formatOptions(form.values)}
                                    placeholder={i18n.get("global.select")}
                                    disabled={disabled}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    );
                }

                throw new Error(`El componente: ${form.component}, no es soportado`);
            })}
        </>
    );
};

DynamicForm.propTypes = {
    forms: instanceOf(Array),
    idForm: string.isRequired,
    disabled: bool,
    docType: string,
};

DynamicForm.defaultProps = {
    forms: [],
    disabled: false,
    docType: "",
};

export default DynamicForm;
